// Captura graficului: cum se face şi unde aşteaptă până o pui undeva.
//
// Două lucruri care până acum lipseau amândouă.
//
// **Desenele nu intrau în captură.** `takeScreenshot()` al bibliotecii de grafice
// desenează doar ce ştie ea: lumânările, axele, volumul. Liniile, dreptunghiurile şi
// nivelurile noastre trăiesc pe o pânză separată, deasupra — iar o captură a unui grafic
// fără tocmai liniile pentru care ai făcut-o n-are rost. Aici cele două se lipesc una
// peste alta, în ordinea în care se văd pe ecran.
//
// **Captura n-avea unde să aştepte.** Mergea în clipboardul sistemului, iar de acolo se
// putea lipi doar unde browserul permite — pe telefon, aproape nicăieri. Acum rămâne şi
// aici, într-un buzunar al aplicaţiei, iar casetele de scris arată un semn că au ce
// ataşa. Buzunarul ţine o singură captură: a doua o înlocuieşte pe prima, fiindcă „care
// dintre cele trei era?" e o întrebare pe care n-o vrea nimeni.

import { bus } from '../core/util.js';

const CHEIE = 'sx_captura';

/**
 * Graficul, cu desene cu tot, ca `data:` URL.
 *
 * `chart` e instanţa noastră (`chart/chart.js`), iar `desene` stratul de desen, dacă
 * există. Fără el se întoarce doar graficul — la fel ca înainte.
 */
export function faCaptura(chart, desene) {
  try {
    const baza = chart.chart.takeScreenshot();
    const panza = document.createElement('canvas');
    panza.width = baza.width;
    panza.height = baza.height;
    const ctx = panza.getContext('2d');
    ctx.drawImage(baza, 0, 0);

    const strat = desene?.canvas;
    if (strat && strat.width) {
      // Pânza de desen acoperă doar panoul principal, care începe din colţul de sus şi
      // e mai îngust decât captura când există axa de preţuri. Ca să nu ghicim, o
      // aşezăm după poziţia reală a celor două elemente pe ecran.
      const rBaza = chart.root.getBoundingClientRect();
      const rStrat = strat.getBoundingClientRect();
      const scara = baza.width / (rBaza.width || 1);
      ctx.drawImage(
        strat,
        (rStrat.left - rBaza.left) * scara,
        (rStrat.top - rBaza.top) * scara,
        rStrat.width * scara,
        rStrat.height * scara,
      );
    }
    return panza.toDataURL('image/webp', 0.85);
  } catch (err) {
    console.warn('[captura] n-a mers', err);
    return '';
  }
}

/** Pune captura în buzunar. Cea veche se pierde: ţinem una singură. */
export function pastreaza(dataUrl, eticheta = '') {
  if (!dataUrl) return;
  try {
    sessionStorage.setItem(CHEIE, JSON.stringify({ url: dataUrl, eticheta, cand: Date.now() }));
  } catch { /* mod privat sau memorie plină — atunci trăieşte doar cât ţine pagina */ }
  memorie = { url: dataUrl, eticheta, cand: Date.now() };
  bus.emit('captura:schimbata', memorie);
}

let memorie = null;

/** Ce aşteaptă în buzunar, dacă aşteaptă ceva. */
export function iaCaptura() {
  if (memorie) return memorie;
  try {
    const brut = sessionStorage.getItem(CHEIE);
    memorie = brut ? JSON.parse(brut) : null;
  } catch { memorie = null; }
  return memorie;
}

export function goleste() {
  memorie = null;
  try { sessionStorage.removeItem(CHEIE); } catch { /* la fel */ }
  bus.emit('captura:schimbata', null);
}

/**
 * Copiază în clipboardul sistemului, dacă browserul lasă.
 *
 * Pe telefon aproape niciodată nu lasă, şi e în regulă: buzunarul de mai sus e drumul
 * principal, iar clipboardul e un plus pentru cine lucrează pe calculator.
 */
export async function inClipboard(dataUrl) {
  try {
    const blob = await (await fetch(dataUrl)).blob();
    const png = await preschimbaInPng(blob);
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': png })]);
    return true;
  } catch {
    return false;
  }
}

/** Clipboardul primeşte PNG; WebP nu-l ştie nimeni acolo. */
function preschimbaInPng(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onerror = reject;
    img.onload = () => {
      const c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      c.toBlob((b) => (b ? resolve(b) : reject(new Error('fără blob'))), 'image/png');
    };
    img.src = URL.createObjectURL(blob);
  });
}
